import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateOperationTypeActions as Actions,
  UpdateOperationTypeRequestAction as RequestAction,
} from 'store/ducks/operationTypes';

export function* updateOperationTypeRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `operation-types/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Tipo de operação atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
